function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { I18nConsumer } from '@wegic/i18n-core';
import { Button, Form, Input } from '@wegic/ui';
import { useCallback, useRef, useState } from 'react';
import { MIN_REQ_EXCEEDS_LIMIT, VERIFY_CODE_ERROR, VERIFY_CODE_EXPIRE } from '@/const/code';
import { EMAIL_REGEXP, FORM_RULES } from '@/const/form';
import { useCountDown } from '@/hooks/useCountDown';
import { resetPassword, sendEmailVerifyCode } from '@/services';
import { LOGIN_I18N_NAMESPACE, loginI18nLoaders } from '../../i18n/loaders';
import styles from './index.module.less';
var FormItem = Form.Item;
function ForgetPasswordFormContent(props) {
    var config = props.config;
    var onEvent = (config || {}).onEvent;
    var _Form_useForm = _sliced_to_array(Form.useForm(), 1), form = _Form_useForm[0];
    var _useCountDown = useCountDown(), restTime = _useCountDown.restTime, setRestTime = _useCountDown.setRestTime;
    var _useState = _sliced_to_array(useState(false), 2), emailValid = _useState[0], setEmailValid = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), submitDisabled = _useState1[0], setSubmitDisabled = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), resetLoading = _useState2[0], setResetLoading = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), visibility = _useState3[0], setVisibility = _useState3[1];
    var visibilityRef = useRef(false);
    visibilityRef.current = visibility;
    var handleSendCode = useCallback(function() {
        return _async_to_generator(function() {
            var email, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = form.getFieldValue('email');
                        setRestTime(59);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            sendEmailVerifyCode(email, 'reset')
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        if (e.code !== MIN_REQ_EXCEEDS_LIMIT) {
                            setRestTime(0);
                        }
                        throw e;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        form,
        setRestTime
    ]);
    var handleResetSubmit = function() {
        return _async_to_generator(function() {
            var formData, _ref, data, code, _obj, message;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setResetLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            4,
                            5
                        ]);
                        return [
                            4,
                            form.validate()
                        ];
                    case 2:
                        formData = _state.sent();
                        if (!formData) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            resetPassword(formData, {
                                allowedCodes: [
                                    VERIFY_CODE_ERROR,
                                    VERIFY_CODE_EXPIRE
                                ]
                            })
                        ];
                    case 3:
                        _ref = _state.sent(), data = _ref.data, code = _ref.code;
                        if (code !== 0) {
                            ;
                            message = (_obj = {}, _define_property(_obj, VERIFY_CODE_EXPIRE, intl.get('ForgetPassword_Form_CodeExpire')), _define_property(_obj, VERIFY_CODE_ERROR, intl.get('ForgetPassword_Form_CodeError')), _obj);
                            form.setFields({
                                code: {
                                    value: '',
                                    error: {
                                        message: message[code]
                                    }
                                }
                            });
                            return [
                                2
                            ];
                        }
                        form.resetFields();
                        if (data) {
                            onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                                type: 'password:reset:success',
                                data: data
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setResetLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var handleValuesChange = function(_, values) {
        var _ref;
        var _values_code, _values_password;
        setSubmitDisabled(((_values_code = values.code) === null || _values_code === void 0 ? void 0 : _values_code.length) !== 6 || !values.email || !values.password || ((_ref = (_values_password = values.password) === null || _values_password === void 0 ? void 0 : _values_password.length) !== null && _ref !== void 0 ? _ref : 0) < 6);
        setEmailValid(EMAIL_REGEXP.test(values.email || ''));
    };
    var InputNumber = useCallback(function(props) {
        var onChange = props.onChange, restProps = _object_without_properties(props, [
            "onChange"
        ]);
        var handleChange = function(value, e) {
            var validValue = value.replace(/\D/g, '');
            onChange && onChange(validValue, e);
        };
        return /*#__PURE__*/ _jsx(Input, _object_spread({
            variant: "white",
            onChange: handleChange
        }, restProps));
    }, []);
    var handleVisibilityChange = function(v) {
        setVisibility(v);
        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
            type: v ? 'privacy:hide' : 'privacy:show'
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles['forget-password'],
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.title,
                children: intl.get('ForgetPassword_Form_Title')
            }),
            /*#__PURE__*/ _jsxs(Form, {
                autoComplete: "off",
                layout: "vertical",
                form: form,
                className: styles.form,
                validateTrigger: [],
                onValuesChange: handleValuesChange,
                children: [
                    /*#__PURE__*/ _jsx(FormItem, {
                        field: "email",
                        rules: FORM_RULES.email,
                        children: /*#__PURE__*/ _jsx(Input, {
                            placeholder: intl.get('Login_Form_EmailPlaceholder'),
                            autoFocus: true,
                            variant: "white",
                            suffix: /*#__PURE__*/ _jsx(Button, {
                                className: styles['send-code'],
                                type: "secondary",
                                disabled: !!restTime || !emailValid,
                                onClick: handleSendCode,
                                size: "small",
                                children: restTime ? "".concat(restTime, "s") : intl.get('ForgetPassword_Form_SendCode')
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(FormItem, {
                        field: "code",
                        children: /*#__PURE__*/ _jsx(InputNumber, {
                            placeholder: intl.get('ForgetPassword_Form_CodePlaceholder'),
                            maxLength: 6
                        })
                    }),
                    /*#__PURE__*/ _jsx(FormItem, {
                        field: "password",
                        rules: FORM_RULES.password,
                        onFocus: function() {
                            setTimeout(function() {
                                if (!visibilityRef.current) {
                                    onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                                        type: 'privacy:show'
                                    });
                                }
                            }, 0);
                        },
                        onBlur: function() {
                            onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                                type: 'privacy:hide'
                            });
                        },
                        children: /*#__PURE__*/ _jsx(Input.Password, {
                            variant: "white",
                            onVisibilityChange: handleVisibilityChange,
                            placeholder: intl.get('Login_Form_PasswordPlaceholder')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                block: true,
                className: styles.submit,
                onClick: handleResetSubmit,
                loading: resetLoading,
                disabled: submitDisabled,
                children: /*#__PURE__*/ _jsx("span", {
                    children: intl.get('ForgetPassword_Form_ButtonText')
                })
            })
        ]
    });
}
function ForgetPasswordForm(props) {
    return /*#__PURE__*/ _jsx(I18nConsumer, {
        loaders: loginI18nLoaders,
        namespace: LOGIN_I18N_NAMESPACE,
        children: /*#__PURE__*/ _jsx(ForgetPasswordFormContent, _object_spread({}, props))
    });
}
export default ForgetPasswordForm;
